export default __webpack_public_path__ + "static/main-4ff25d4cfeefec03fd16afff1e08ac8f.jpg";